<div 
    class="chat-toggle cursor-pointer bg-white rounded-full shadow-lg w-14 h-14 flex items-center justify-center transition-all duration-300 hover:shadow-xl hover:scale-105 active:scale-95"
    (click)="toggleChat()"
  >
    
    <div class="relative w-8 h-8">
      
      <span 
        class="absolute inset-0 flex items-center justify-center text-2xl font-light text-gray-700 transition-all duration-300"
        [class.opacity-0]="!isChatOpen"
        [class.opacity-100]="isChatOpen"
        [class.rotate-90]="!isChatOpen"
        [class.rotate-0]="isChatOpen"
      >
        −
      </span>
      
      
      <div 
        class="absolute inset-0 flex items-center justify-center transition-all duration-300"
        [class.opacity-100]="!isChatOpen"
        [class.opacity-0]="isChatOpen"
        [class.scale-100]="!isChatOpen"
        [class.scale-0]="isChatOpen"
      >
        <span *ngIf="!isChatOpen">
          <img 
            [src]="logoJulia" 
            alt="IBS" 
            class="w-8 h-8 object-contain transition-transform duration-300"
          />
        </span>
      </div>
    </div>
  </div>

<div class="chat-container shadow-md" *ngIf="isChatOpen">
  <div class="chat-header p-3 border-b flex justify-between items-center">
    <h6>
      <img [src]="logoJulia" alt="Logo" class="inline-block w-6 h-6 mr-2" />
      {{ 'julia.chat.title' | translate }}
    </h6>

    <button class="btn btn-sm btn-primary" (click)="createNewSession()">
      {{ 'julia.chat.new_discussion' | translate }}
    </button>
  </div>

  <div class="sessions-select p-3 border-b">
    <div class="dropdown-container">
      <button
        class="dropdown-toggle-btn w-full bg-white border border-gray-300 rounded-md py-2 px-3 text-left"
        id="dropdownSessions"
        (click)="toggleSessionDropdown()"
      >
        <span class="block text-xs font-medium">
          {{
            selectedSession
              ?  selectedSession.session_title
              : ('julia.chat.select_session' | translate)
          }}
        </span>
      </button>

      <div
        *ngIf="searchOpened"
        aria-labelledby="dropdownSessions"
        class="dropdown-menu-custom bg-white shadow-lg mt-2 rounded-md w-full"
      >
        <div
          *ngIf="loadingSessions"
          class="text-center text-xs text-gray-500 p-2"
        >
          {{ 'julia.chat.loading_discussions' | translate }}
        </div>

        <button
          *ngFor="let s of sessions"
          class="dropdown-item-custom px-4 py-2 hover:bg-gray-200 rounded-md w-full text-left"
          (click)="selectSession(s)"
          [class.active]="selectedSession?.id === s.id"
        >
          <div class="user-container">
            <span class="block text-xs font-medium">{{ s.session_title }}</span>
            <span class="client-name text-xs">{{
              s.created_at | date : "short"
            }}</span>
          </div>
        </button>
      </div>
    </div>
  </div>

  <!-- Workflow Tasks Display - At Top -->
  <div class="tasks-container" *ngIf="currentTasks.length > 0">
    <div class="tasks-header">{{ 'julia.chat.tasks_plan' | translate }}</div>
    <div
      *ngFor="let task of currentTasks"
      class="task-item"
      [ngClass]="getTaskStatusClass(task)"
    >
      <div class="task-icon">
        <div class="icon-circle" [ngClass]="'status-' + (task.status || 'pending')"></div>
      </div>
      <div class="task-content">
        <div class="task-name">{{ task.status === "completed" ?task.friendly_completion_message :  task.friendly_description  }}</div>
      </div>
    </div>
  </div>

  <div class="messages-container flex-1 p-3 overflow-y-auto" #scrollContainer>
    <div *ngIf="loadingMessages" class="text-center text-xs text-gray-500">
      {{ 'julia.chat.loading_messages' | translate }}
    </div>

    <div
      *ngFor="let msg of messages"
      class="message-wrapper mb-2"
      [ngClass]="[
        isMessageSentByUser(msg) ? 'sent' : 'received',
        !isMessageSentByUser(msg) ? getMessageEventClass(msg) : ''
      ]"
    >
      <div *ngIf="!isMessageSentByUser(msg)" class="avatar pt-1">
        <img 
          [src]="logoJulia" 
          alt="Julia" 
          class="w-6 h-6 object-contain"
        />
      </div>
      <div class="message-bubble p-2 rounded-md" [class.with-blocks]="messageBlocks(msg).length">
        <app-custom-markdown [data]="messageText(msg)"></app-custom-markdown>
        <app-julia-block-host
          *ngFor="let block of messageBlocks(msg); trackBy: trackBlock"
          [block]="block"
          [sessionId]="msg.session_id"
          (expired)="blocksExpired(msg)">
        </app-julia-block-host>
      </div>
    </div>

    <!-- Action Requests - Inline Validation -->
    <div class="action-requests-container" *ngIf="pendingActionRequests.length > 0">
      <div *ngFor="let actionRequest of pendingActionRequests" class="action-request-wrapper mb-2">
        <div class="message-wrapper received action-request">
          <div class="avatar pt-1">
            <img 
              [src]="logoJulia" 
              alt="Julia" 
              class="w-6 h-6 object-contain"
            />
          </div>
          <div class="action-request-bubble p-3 rounded-md">
            <div class="action-request-header mb-2">
              <span class="text-xs font-medium">{{ actionIcon(actionRequest) }} {{ headerKey(actionRequest) | translate }}</span>
            </div>
            <div class="action-request-content mb-2">
              <div class="text-sm">{{ actionMessage(actionRequest) }}</div>
            </div>
            <div class="action-request-buttons flex gap-2">
              <button 
                class="btn-action btn-preview flex-1"
                (click)="openPreviewModal(actionRequest)"
              >
                {{ 'julia.action_request.preview' | translate }}
              </button>
              <button 
                class="btn-action btn-approve"
                (click)="approveActionRequest(actionRequest)"
              >
                {{ approveKey(actionRequest) | translate }}
              </button>
              <button 
                class="btn-action btn-deny"
                (click)="denyActionRequest(actionRequest)"
              >
                {{ denyKey(actionRequest) | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="temporary-messages-container" *ngIf="temporaryMessages.length > 0">
      <div *ngFor="let msg of temporaryMessages" class="temporary-message">
        <div class="avatar">
          <img 
            [src]="logoJulia" 
            alt="Julia" 
            class="w-6 h-6 object-contain"
          />
        </div>
        <div class="spinner-loader"></div>
        <span class="temporary-message-text">{{ msg.content }}</span>
      </div>
    </div>

    
    <div class="message-wrapper thinking" *ngIf="loadingAssistant && temporaryMessages.length === 0">
      <div class="avatar py-2">
        <img 
          [src]="logoJulia" 
          alt="Julia" 
          class="w-6 h-6 object-contain"
        />
      </div>
      <div class="message-bubble typing-indicator">
        <span></span><span></span><span></span>
      </div>
    </div>
  </div>

  <div class="message-input p-2 border-t flex">
    <textarea
      class="form-control flex-1 p-2 rounded-md border"
      [(ngModel)]="newMessage"
      [placeholder]="'julia.chat.write_message' | translate"
      (keydown.enter)="!isSubscriptionActive() && sendMessage(); $event.preventDefault()"
      [disabled]="isSubscriptionActive()"
    ></textarea>
    <button
      *ngIf="!isSubscriptionActive()"
      class="btn btn-primary ml-2"
      (click)="sendMessage()"
      [disabled]="!newMessage.trim()"
    >
      {{ 'julia.chat.send' | translate }}
    </button>
    <button
      *ngIf="isSubscriptionActive()"
      class="btn btn-danger ml-2"
      (click)="cancelRequest()"
    >
      {{ 'julia.chat.stop' | translate }}
    </button>
  </div>
  </div>

<!-- Custom Action Preview Modal -->
<div *ngIf="showPreviewModal" class="custom-modal-overlay" (click)="closePreviewModal()">
  <div class="custom-modal-dialog" (click)="$event.stopPropagation()">
    <app-action-preview-modal 
      *ngIf="selectedActionRequestForPreview"
      [actionRequest]="selectedActionRequestForPreview"
      (actionSelected)="onModalAction($event)"
      (modalClosed)="closePreviewModal()">
    </app-action-preview-modal>
  </div>
</div>